import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/footer";

export const Login: React.FC = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogin = async () => {
      if (!isAuthenticated) {
        await loginWithRedirect();
      }
    };
    handleLogin()
  }, [isAuthenticated, loginWithRedirect, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-4xl w-full bg-white shadow-xl rounded-lg overflow-hidden">
        <div className="flex">
          {/* Left side - Login form */}
          <div className="w-1/2 p-8">
            <div className="max-w-md mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">
                  Welcome Back
                </h2>
                <p className="text-gray-600">
                  Sign in to your account
                </p>
              </div>
              
              <div className="space-y-6">
                <div className="text-center">
                  <button
                    onClick={() => loginWithRedirect()}
                    className="w-full flex justify-center items-center px-4 py-3 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                  >
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                    </svg>
                    Sign In with Auth0
                  </button>
                </div>
                
                <div className="text-center">
                  <p className="text-sm text-gray-500">
                    Secure authentication powered by Auth0
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right side - Banner style layout matching the image */}
          <div className="w-1/2 bg-gray-800 flex items-center p-8">
            <div className="flex items-center w-full">
              {/* Logo on the left */}
              <div className="flex-shrink-0 mr-8">
                <div className="text-center">
                  <img 
                    src="/v-logo-dark.png" 
                    alt="VitalHive Logo" 
                    className="w-16 h-16 mx-auto mb-2"
                  />
                  <div className="space-y-0">
                    <p className="text-xs font-bold tracking-wide" style={{ color: '#FFD700' }}>
                      VITALHIVE
                    </p>
                    <p className="text-xs font-bold tracking-wide" style={{ color: '#FFD700' }}>
                      TECHNOLOGIES
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Text on the right */}
              <div className="flex-1">
                <h1 className="text-4xl font-bold tracking-wide mb-2" style={{ color: '#FFD700' }}>
                  VitalHive
                </h1>
                <p className="text-lg font-medium" style={{ color: '#D3D3D3' }}>
                  Healthcare Staffing
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};